/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_CurrentInputs */

const en_pricing_current = /** @type {(inputs: Pricing_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current plan`)
};

const id_pricing_current = /** @type {(inputs: Pricing_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket aktif`)
};

/**
* | output |
* | --- |
* | "Current plan" |
*
* @param {Pricing_CurrentInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pricing_current = /** @type {((inputs?: Pricing_CurrentInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_CurrentInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pricing_current(inputs)
	return en_pricing_current(inputs)
});